var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('apexchart',{staticClass:"statistics-widget-3-chart card-rounded-bottom",attrs:{"options":_vm.options,"series":_vm.series,"height":280,"type":"bar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }